module.exports = __webpack_public_path__ + "assets/rise.bab298c2.svg";